import { LmpHeroSticky, ILmpHeroSticky } from '@sky-it-livedata/livedata-sports-design-system';
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LmpHeroStickyQuery, LmpHeroStickySubscription } from "./types";
import transformerQuery from "./transformers/query";
import transformerSubscription from "./transformers/subscription";
import { graphql } from "appsync";
import { useSubscription } from "../../hooks/useSubscription";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LmpHeroStickyQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

const subscriptionDocument = graphql('subscription LmpHeroStickySubscription($matchId: ID!) {\n  onUpdateLmpHeroStickyByMatchId(matchId: $matchId) {\n    matchId\n    status\n    home {\n      goal\n      overtimeGoal\n      penaltiesGoal\n      regularTimeGoal\n      shootoutGoal\n      totalGoalLegs\n    }\n    away {\n      goal\n      overtimeGoal\n      penaltiesGoal\n      regularTimeGoal\n      shootoutGoal\n      totalGoalLegs\n    }\n  }\n}');

export const getServerProps = ({
  props,
}: WidgetContext<LmpHeroStickyQuery>): ILmpHeroSticky => {
  return transformerQuery(props);
}

const LmpHeroStickyWidget = ({
  props,
  variables,
  ...rest
}: WidgetContext<ILmpHeroSticky>) => {
  log({ props, variables, ...rest });


  const updatedProps = useSubscription<
    ILmpHeroSticky,
    LmpHeroStickySubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformerSubscription,
    mergeData: true,
  }) as ILmpHeroSticky;

  return (
      <LmpHeroSticky {...updatedProps}  />
  );
}

export default LmpHeroStickyWidget;